import axios from 'axios';
import logger from '../util/logging.client';

/**
 * @name getStrapiCollections - gets data from Strapi CMS
 * @param {string} collectionType - the collection type
 * @param {string} modalID - the modal ID
 * @returns {Promise<import('axios').AxiosResponse>} Promise and resolves the data from Strapi CMS
 */
const getStrapiCollections = async (collectionType, modalID) => {
  try {
    const URL = `/online-acquisition-cms/api/${collectionType}?populate=deep&filters[modalID][$eq]=${modalID}`;
    const { data: cmsData } = await axios.get(URL);
    return cmsData.data[0];
  } catch (error) {
    if (process.env.NEXT_PUBLIC_DEBUG === 'true') {
      logger.log('error', 'error', error);
    }
    return null;
  }
};

export default getStrapiCollections;
